import React from 'react';
import styled from 'styled-components';
import { notEmpty } from 'utilities';
import Chip, { ChipCss } from '../Chips';
import RichTextEditor from '../Editors/RichTextEditor';
import { ProductButton } from '../AppButton';
import { CheckmarkCircleOutline } from "@styled-icons/evaicons-outline/CheckmarkCircleOutline";

type BoxCustomStyleType = {
  width?: string;
  background?: string;
  isBought?: boolean;
}

const Box3dContainer = styled.div`
  position: relative;
  min-height: 325px;
  width: ${(props: any) => props.width ?? '320px'};
  margin-bottom: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
  transition: 0.3s;
  background: ${(props: any) => props.background};
  border-radius: 16px;
  margin-right: 24px;
  border-color: ${(props: any) => props.selected ? '#0080008c' : '#00000020'};
  &:hover {
    box-shadow: 0 16px 25px 0 rgba(0, 0, 0, 0.5);
  }
  .box3d__icon {
    margin-bottom: 16px;
    position: relative;
    img {
      width: 70px
    }
  }
  .selected-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    color: green;
    font-weight: 500;
    font-size: 18px;
    width: 30px;
  }
  .coaching-text{
    position: absolute;
    top: 30px;
    left: 17px;
    color: white;
    font-weight: 500;
    font-size: 18px;
  }
  .mock-text{
    position: absolute;
    top: 30px;
    left: 15px;
    font-weight: 500;
    color: white;
    display: none;
  }
  .box3d__body {
    height: 100%;
    color: #000;
    flex-grow: 1;
    background: unset;
  }
  .title {
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 26px;
    color: #000000;
    text-align: left;
  }
  .text {
    margin-top: 10px 0;
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    text-align: justify;
    letter-spacing: 0.32px;
    color: rgba(0, 0, 0, 0.74);
    height: ${(props: any) => props.isBought ? `125px` : `155px`};
  }

  .ql-editor{
    ::-webkit-scrollbar {
      width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px grey;
      border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: grey;
      border-radius: 10px;
      cursor: pointer !important;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #b8b4b4;
    }
  }
  .view_more_link {
    font-family: IBM Plex Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.16px;
    text-decoration-line: underline;
    color: #5b94e3;
    cursor: pointer;
  }
  .box3d__message {
    font-style: italic;
    font-size: 13px;
  }
  .box3d__foot {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;

    Button {
      color: white;
      height: auto;
      background: #e25252;
      font-size: 15px;
    }
  }
`;

export default function ProductBox(props: IProps) {
  return (
    <Box3dContainer {...{...props.style, selected: props.meetingPaidButNotScheduled}} className={props.className}>
      {props.icon &&
        <div className="box3d__icon">
          <img src={props.icon} alt="track_icon" />
          <div className={`${props.title.includes('Coaching') ? 'coaching-text' : 'mock-text'}`}>{props.title.includes('Coaching') ? "C" : "M"}</div>
        </div>
      }
      {props.meetingPaidButNotScheduled && 
        <CheckmarkCircleOutline data-tip data-for={"Selected expert"} className={'selected-icon'} />
      }
      <div className="box3d__body">
        <div className="title">{props.title}</div>
        <div className="text">
          <p className="description">
            <RichTextEditor
              doNotAllowCopy={true}
              disabled={true}
              id={`pBox-${props.id}`}
              value={props.description}
              customStyles={{ background: `${(props: any) => props.background ?? '#f9fafc'}`, maxHeight: props.isBought ? '120px' : '140px', resize: 'none', boxShadow: 'none', minHeight: '0', border: 'none' }}
            />
          </p>
        </div>
      </div>
      {props.isBought ?
        <p className="badge badge-primary box3d__message">* You have already paid, please schedule.</p> : <></>
      }
      <div className="box3d__foot">
        <ProductButton type="button" className="payment-btn" onClick={() => props.clickHandler(props.id, props.title)}>{props.btnLabel}</ProductButton>
        {notEmpty(props.tag) && <Chip value={props.tag} style={props.tagCss} />}
      </div>
    </Box3dContainer>
  );
}

interface IProps {
  className?: string;
  id: string;
  title: string;
  description: string;
  icon?: string;
  btnLabel: string;
  clickHandler: (id: any, metadata: string) => void;
  tag: string;
  meetingPaidButNotScheduled: boolean;
  tagCss?: ChipCss;
  style?: BoxCustomStyleType;
  isBought?: boolean;
}
